export default "__VITE_ASSET__cj_sKWa8__"